import { createUseStyles } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';

export default createUseStyles(
  {
    '@global body': {
      margin: 0,
    },
    root: {
      background: ({ theme }: { theme: CustomCiamUiTheme }) =>
        theme.backgroundColor,
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      justifyContent: 'center',
      height: 'fit-content',
      minHeight: '100vh',
      width: '100vw',
      fontFamily: 'Roboto',
      overflow: 'hidden',
    },
    errorIcon: {
      margin: 'auto',
      textAlign: 'center',
      paddingTop: 30,
    },
    icon: {
      paddingBottom: 24,
    },
    logo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: 50,
      padding: [24, 0],
    },
    widget: {
      width: '400px',
      height: 'auto',
      background: '#fff',
      borderRadius: '16px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
      border: 'none',
      zIndex: 0,
      ['@media (max-width: 768px)']: {
        width: 340,
      },
    },
    header: {
      textAlign: 'center',
      padding: [44, 40, 24],
    },
    headerWithError: {
      textAlign: 'center',
      padding: [10, 40, 8],
    },
    title: {
      fontWeight: 450,
      fontSize: '1.5rem',
      textAlign: 'center',
    },
    description: {
      lineHeight: '20px',
      fontSize: '14px',
      textAlign: 'center',
      marginTop: 16,
      color: 'rgba(0, 0, 0, 0.55)',
    },
    footer: {
      width: '400px',
      fontSize: 12,
      margin: [30, 0],
    },
    form: {
      padding: [0, 40, 30],
    },
    mailIcon: {
      textAlign: 'center',
      margin: 'auto',
      width: 'fit-content',
      paddingTop: 50,
      marginBottom: -12,
    },
    renderedLink: {
      textAlign: 'center',
      marginTop: -10,
      marginBottom: 40,
    },
    wrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  {
    name: 'Auth0Widget',
  },
);
